(function () {
    function eraseCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }
    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    const notification = document.getElementById("notification")
    if (notification) {
        const md5 = notification.dataset.md5
        const notificationCookie = getCookie("notification")
        console.log(md5, notificationCookie, notificationCookie && notificationCookie == md5)
        if (notificationCookie && notificationCookie == md5) {
            notification.classList.add("collapsed")
        } else {
            notification.classList.remove("hide")
        }
        notification.classList.remove("hide")

        const notificationBtns = notification.querySelectorAll("button")
        console.log(notificationBtns)

        for (let i = 0; i < notificationBtns.length; i++) {
            const notificationBtn = notificationBtns[i]
            notificationBtn.addEventListener("click", (e) => {
                e.preventDefault()
                if (notification.classList.contains("collapsed")) {
                    notification.classList.remove("collapsed")
                    eraseCookie("notification")
                } else {
                    notification.classList.add("collapsed")
                    const dismissedEl = notification.querySelector(".dismissed")
                    dismissedEl.classList.remove("collapsed")
                    setCookie("notification", md5, 365)
                    if (notification.closest(".homepage").length == 0) {
                        notification.classList.add("hide")
                    }
                }
            })
        }
    }

})();